import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Bredcom from '../components/Bredcom/Bredcom';
import Footer from '../components/Footer/Footer';

function MedjunarodnaSaradnja () {
    return (
        <>
        <Navbar/>
        <Bredcom title="Početna" subtitle="Međunarodna saradnja" />
        <Footer />
        </>
    )
}
export default MedjunarodnaSaradnja;